// @core/api/endpoints/authn/list_oauth2_consents.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListOAuth2ConsentsResponse,
} from '../../../types/authn';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/authn';

/**
 * List OAuth2 consents for user
 * Returns a paginated list of all OAuth2 consents granted by the current user. Shows which applications have access and what scopes have been granted.
 */
export async function ListOAuth2Consents(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListOAuth2ConsentsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/consents`;
  const requestOptions = options;
  return client.get<ListOAuth2ConsentsResponse>(requestPath, { ...requestOptions, params });
}
